import type { ColumnDef } from '../projects/projectsColumns';

export const clientsColumns: ColumnDef[] = [
  { field: 'ClientId', headerName: 'Client ID', sortable: true, width: 90 },
  { field: 'ClientName', headerName: 'Client Name', sortable: true, flex: 1.5 },
  { field: 'ContactPerson', headerName: 'Contact Person', sortable: true, flex: 1 },
  { field: 'Email', headerName: 'Email', sortable: true, flex: 1 },
  { field: 'Phone', headerName: 'Phone', sortable: true, width: 120 },
  { field: 'ProjectCount', headerName: 'Projects', sortable: true, width: 80 },
  { field: 'ClientStatus', headerName: 'Status', sortable: true, width: 90, type: 'status' },
  { field: 'sysLastModifiedDate', headerName: 'Last Modified', sortable: true, width: 115 },
];
